/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import classes from "./NewActualDesign.module.scss"
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { FacebookShareButton, LinkedinIcon, TwitterShareButton, WhatsappShareButton } from 'react-share';
import copy from 'copy-to-clipboard';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Days from '../tripOverview/days';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import cx from "classnames";
import SailingIcon from '@mui/icons-material/Sailing';
import { SEND_EMAIL, UPDATE_DYNAMIC_ACCOMMODATION, UPDATE_DYNAMIC_ACTIVITY, UPDATE_DYNAMIC_CARRENTAL, UPDATE_DYNAMIC_FERRY, UPDATE_DYNAMIC_FLIGHT, UPDATE_DYNAMIC_RESTAURANT, UPDATE_DYNAMIC_TRAIN } from '../../graphQL/mutations';
import { useMutation } from '@apollo/client';
import { useAuth0, User } from '@auth0/auth0-react';
import SuccessPage from '../tripOverview/successPage';
import { getENVData } from '../../constants/constantValue';
import { BackSlideSvg, CopyLinkSvg, CopySvg, CruiseSvg, DownloadSvg, FacebookSvg, FlightSvg, ForSlideSvg, HintsSvg, InformationSvg, LinkSvg, SensitiveSvg, TwitterSvg, WhatsAppSvg } from '../../constants/resources';
import EmailTemplate from '../../atom/EmailTemplate';
import { ItineraryInsurance, SortedItem, TravelAnswer, UserProfile, itinerary } from '../../atom/Types';
import { RootState } from '../../App';
import { checkSpacing, isCruise, isFerry, isFlight, keyExistInObject } from '../../atom/utilities/function';
import PDF_REPORT_DOCUMENT from '../tripOverview/pdfViwer';
// import { selectArray } from '../NewProposalDesign/VeryNewProposlDesign';
import * as  Actions from '../../store/actions'
import InsuranceSlider from './insuranceSlider';

interface props {
    modal: string | boolean
    setModal: React.Dispatch<React.SetStateAction<string | boolean>>
    shareClick: boolean
    setShareClick: React.Dispatch<React.SetStateAction<boolean>>
    buliddata: itinerary | undefined
    setbuilddata: React.Dispatch<React.SetStateAction<itinerary | undefined>>
    shareTypeClick: string | boolean
    setShareTypeClick: React.Dispatch<React.SetStateAction<string | boolean>>
    copyLink: string | boolean
    setCopyLink: React.Dispatch<React.SetStateAction<string | boolean>>
    flag: boolean
    setSuccessEmail: React.Dispatch<React.SetStateAction<string>>
    successEmail: string
    Itinerarydata: TravelAnswer
}
interface selectArray {
    day: number | null | undefined
    data: SortedItem
}

const NewActualDesign: React.FC<props> = ({ modal, setModal, shareClick, setShareClick, buliddata, setbuilddata, shareTypeClick, setShareTypeClick, copyLink, setCopyLink, successEmail, setSuccessEmail, flag, Itinerarydata }) => {

    const { ShareType, Profile } = useSelector((state: RootState) => state?.Question);
    const [copyy, setCopy] = useState(false)
    const [date, setDate] = useState('')
    const [indexx, setIndexx] = useState(0)
    const [newURL, setNewURL] = useState('')
    const { user, isAuthenticated } = useAuth0()
    const [modals, setModals] = useState(false)
    const [selectArray, setSelectedArray] = useState<selectArray[]>([])
    const [cartItems, setCartItems] = useState<any>([])
    const ENV = getENVData()
    const dispatch = useDispatch()
    const [days, setDays] = useState('')
    const [currentIndices, setCurrentIndices] = useState<{ start: number; end: number }[]>([])
    const env = getENVData()

    const [Email] = useMutation(SEND_EMAIL, {
        onError: (error) => {

        }
    })

    const [AccommodationStatus] = useMutation(UPDATE_DYNAMIC_ACCOMMODATION, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [TrainStatus] = useMutation(UPDATE_DYNAMIC_TRAIN, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [FerryStatus] = useMutation(UPDATE_DYNAMIC_FERRY, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [FlightStatus] = useMutation(UPDATE_DYNAMIC_FLIGHT, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [CarRentalStatus] = useMutation(UPDATE_DYNAMIC_CARRENTAL, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [RestaurantStatus] = useMutation(UPDATE_DYNAMIC_RESTAURANT, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [ActivityStatus] = useMutation(UPDATE_DYNAMIC_ACTIVITY, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    useEffect(() => {
        let temp: any = []
        if (buliddata?.itineraryInsurance)
            for (let index = 0; index < buliddata?.itineraryInsurance?.length; index++) {
                temp.push({ start: 0, end: window.innerWidth > 600 ? 2 : 0 })
            }
        setCurrentIndices(temp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.innerWidth])

    console.log(`https://dev.travelsment.com/viewer/?success=true&message=You%20can%20now%20login%20to%20the%20application%20with%20the%20new%20password`.split("=")[1], 'currentIndices');


    useEffect(() => {
        setShareTypeClick(true)
        if (buliddata) {
            let temp: any = []
            let items = localStorage.getItem(buliddata.key)
            if (items !== null) {
                let updateData = { ...buliddata }
                if (updateData) {
                    updateData.itineraryInsurance.forEach((ins) => {
                        ins['insurances'].forEach((node) => {
                            items && JSON.parse(items).forEach((item: any) => {
                                if (item.id === node.id) {
                                    node.selected = true
                                    temp.push(node)
                                }
                            })
                        })
                    })
                    updateData.days.forEach((day) => {
                        if (day.sorted && day.sorted?.length > 0) {
                            day.sorted?.filter((node) => { return node.type === 'activity' || node.type === 'train' || node.type === 'flight' || node.type === 'carRental' }).forEach((n: any) => {
                                items && JSON.parse(items).forEach((item: any) => {
                                    if (item.id === n.id) {
                                        n.selected = true
                                        temp.push(n)
                                    }
                                    else if (item.id === n?.returnItineraryFlight?.id) {
                                        n.returnItineraryFlight.selected = true
                                        temp.push(n.returnItineraryFlight)
                                    }
                                })
                            })
                        }
                        if (day.dayAccommodations && day.dayAccommodations.length > 0) {
                            day.dayAccommodations.forEach((n: any) => {
                                items && JSON.parse(items).forEach((item: any) => {
                                    if (item.id === n.id) {
                                        console.log(n, 'nooooor', item);
                                        n.selected = true
                                        temp.push(n)
                                    }
                                })
                            })
                        }
                    })
                }
                dispatch(Actions.cartLength(temp.length))
                setCartItems(temp)
                setbuilddata(updateData)
            }
        }
    }, [])

    useEffect(() => {
        if (window.location.href.split('#')[1])
            window.history.replaceState(null, '', window.location.pathname);
        const handleHashChange = () => {
            if (typeof window !== 'undefined') {
                setDays(window.location.hash);
            };
        }
        window.addEventListener('hashchange', handleHashChange);
        handleHashChange();
        return () => {
            window.removeEventListener('hashchange', handleHashChange);

        };

    }, []);

    console.log(cartItems, 'cartItems');



    const Copy = (index: any, node: any) => {
        if (node.departDate) {
            setDate(node.departDate)
        }
        else {
            setDate(node.departureDate)
        }

        setCopy(true)
        setIndexx(index)
        setTimeout(() => {
            return setCopy(false);
        }, 1000);
    }

    const submitProposal = () => {
        setModals(true)
        if (isAuthenticated && (Itinerarydata?.email?.toLowerCase() === (keyExistInObject(Profile as UserProfile, "email") as String)?.toLowerCase() ||
            Itinerarydata?.sharedEmails?.map(m => m.toLowerCase()).includes(keyExistInObject(Profile as UserProfile, "email").toString().toLowerCase()))) {
            const promises: any = []
            const apiCalls = [
                { type: 'accommodation', apiFunction: AccommodationStatus },
                { type: 'train', apiFunction: TrainStatus },
                { type: 'ferry', apiFunction: FerryStatus },
                { type: 'flight', apiFunction: FlightStatus },
                { type: 'carRental', apiFunction: CarRentalStatus },
                { type: 'Restaurant', apiFunction: RestaurantStatus },
                { type: 'activity', apiFunction: ActivityStatus }
            ];
            setSuccessEmail('Loading')
            buliddata?.days?.forEach((day) => {
                day.sorted && day.sorted.forEach((node) => {
                    const apiCall = apiCalls.find((call) => call.type === node.type && node.selected && 'bookingStatus' in node && node.bookingStatus === 'Proposal');
                    if (apiCall) {
                        promises.push(new Promise(resolve => {
                            apiCall.apiFunction({
                                variables: { id: node.id, bookingStatus: "InProgress", isVisible: true }
                            }).then(res => resolve(res))
                                .catch(err => resolve(err));
                        }));
                    }
                });
            });

            if (promises.length > 0 && buliddata) {
                Promise.all(promises).then(async () => {
                    setSuccessEmail('Loading')
                    const email = EmailTemplate(buliddata, keyExistInObject(Profile as UserProfile, '') as UserProfile, user as User, [], '');


                    if (email) {

                        Email({
                            variables: {
                                to: env.email,
                                ccEmails: env.subEmail,
                                subject: `${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname},  ${buliddata?.name} , has submitted actual`,
                                body: email,
                                submitTime: 1685950252
                            }
                        }).then((response) => {


                            if (response.errors === undefined) {
                                setSuccessEmail('Success')
                                if (buliddata && cartItems.length > 0) {
                                    window.location.assign(`${buliddata?.key}/cart`)
                                }
                            } else {
                                setSuccessEmail('Error')
                            }
                        })
                    }
                }).catch((err) => {

                    setSuccessEmail('failed')
                    // submitProposal()

                })
            }
            else {
                setModals(false)
                if (buliddata && cartItems.length > 0) {
                    window.location.assign(`${buliddata?.key}/cart`)
                }
            }


        }
        else if (isAuthenticated && (Itinerarydata?.email !== keyExistInObject(Profile as UserProfile, "email") && !Itinerarydata?.sharedEmails?.includes(keyExistInObject(Profile as UserProfile, "email").toString()))) {
            setSuccessEmail('misMatch')
        }
        else {
            setSuccessEmail('notLogged')
        }
    }

    useEffect(() => {
        setTimeout(() => {
            const elm: any = document.getElementById('eventMonitor')
            if (elm) {
                const aTag = elm.getElementsByTagName('a');
                for (var node of aTag) {
                    if (!node.getAttribute('href').includes('#'))
                        node.setAttribute('target', '_blank');
                }
            }
        }, 200);
    }, [buliddata])

    const handelCopyLink = () => {
        copy(newURL, {
            debug: true,
            message: 'Copy',
        });

        copy(newURL)
        setCopyLink(shareTypeClick)
        setShareTypeClick(true)
        setTimeout(() => {
            setCopyLink('')
        }, 1000)
        setModal(false)
    }

    const publicShare = () => {

        if (shareTypeClick === 'publicShare') {
            setShareTypeClick(true)
        } else setShareTypeClick('publicShare')

    }

    const share = (str: any) => {

        if (str === 'sharewithfamily') {
            if (shareTypeClick === 'shareWithFamily')
                setShareTypeClick(true)
            else
                setShareTypeClick('shareWithFamily')
        }
        else if (str === 'publicshare') {
            if (shareTypeClick === 'publicShare')
                setShareTypeClick(true)
            else
                setShareTypeClick('publicShare')
        }
        else {
            setShareTypeClick(true)
        }

        if (newURL === '') {
            let equalseprate = ''
            let url = window?.location?.href.split("v1/")[1];
            if (window?.location?.href.split("share/")[1] && ShareType === 'friends') {
                setNewURL(window.location.href)
            } else if (!window?.location?.href.split("v1/")[1].includes('share/')) {
                let encodedData = btoa(`share=${'friends'}&id=${url}`);
                if (encodedData.slice(-1) === '=') {
                    equalseprate = encodedData.substring(0, encodedData.length - 1)
                }
                if (equalseprate.slice(-1) === '=') {
                    equalseprate = equalseprate.substring(0, encodedData.length - 1)
                }
                let newurl = `${ENV.url}/viewer/v1/share/${equalseprate ? equalseprate : encodedData}`


                setNewURL(newurl)
            }
        }
        setShareClick(false)
        if (shareTypeClick === false) {
            setNewURL('')
        }
    }
    const revertDate = (date: string) => {
        var split = date.split('-');
        if (+split[2] > 1000) {
            date = split[2] + "-" + split[1] + "-" + split[0]
        }
        return date;
    }

    const handleSlide = (node: string, scrollIndex: number) => {
        if (node === 'forwards') {

            let updateIndices = [...currentIndices]
            updateIndices[scrollIndex].start = updateIndices[scrollIndex].start + 1
            updateIndices[scrollIndex].end = updateIndices[scrollIndex].end + 1

            setCurrentIndices(updateIndices)
        }
        else {
            let updateIndices = [...currentIndices]
            updateIndices[scrollIndex].start = updateIndices[scrollIndex].start - 1
            updateIndices[scrollIndex].end = updateIndices[scrollIndex].end - 1
            setCurrentIndices(updateIndices)

        }
    }

    const handleButtonName = () => {
        if (cartItems.length > 0)
            return 'Proceed to cart'
        else
            return 'Submit'
    }

    const handleInsurance = (node: ItineraryInsurance, index: number) => {
        let updateData = { ...buliddata } as itinerary
        let updatedArray = [...selectArray];
        let updatedCartItems = [...cartItems];

        if (updateData.itineraryInsurance && buliddata) {

            updateData.itineraryInsurance[index].insurances.forEach((ins) => {
                if (node.id === ins.id) {
                    console.log(index, 'index');
                    ins.selected = !ins.selected;
                } else {
                    ins.selected = false;
                }

                if (ins.selected) {
                    console.log(ins, 'insssssis');

                    if (!updatedCartItems.some((item) => item.id === node.id)) {
                        updatedCartItems.push(node);
                    }
                    if (!updatedArray.some((item) => item.data.id === node.id)) {
                        updatedArray.push({ day: node.day, data: node });
                    }
                } else {
                    console.log(ins, 'insssssis');

                    const reqIndex = updatedCartItems.findIndex((cart) => cart.id === ins.id);

                    if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                    const arrayIndex = updatedArray.findIndex((n) => n.data.id === ins.id);
                    if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
                }
            });

            setSelectedArray(updatedArray);
            setCartItems(updatedCartItems);

            dispatch(Actions.cartLength(updatedCartItems.length));
            localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));

            setbuilddata({ ...updateData });
        }

    }

    console.log(buliddata, 'buliddata');


    return (
        <div className={classes.MainContainer}>
            <div className={classes.ShareButton} >
                <div style={{ display: 'flex', gap: '20px' }}>
                    {copyLink === 'publicShare' || copyLink ? <button className={classes.ButtonS}>Copied</button> : <button className={shareTypeClick === 'publicShare' || !shareTypeClick ? classes.ButtonS : classes.ButtonS} onClick={() => { buliddata?.parentRef === null ? share('publicshare') : publicShare() }}>Share With Friends</button>}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <InformationSvg />
                        <span className={classes.shareFriends}>no personally identifiable information will be shared</span>
                    </div>
                </div>

                <div>
                    {buliddata?.type === "Actual" && ShareType !== 'friends' ?

                        <div className={classes.PrintBox}  >
                            <div className={classes.print} title={"Click here to PDF"}>
                                <PDFDownloadLink document={<PDF_REPORT_DOCUMENT buliddata={buliddata} />} fileName={buliddata?.name + '.pdf'}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                        <DownloadSvg />
                                        <p>Download trip details</p>
                                    </div>
                                </PDFDownloadLink>
                            </div>
                        </div>
                        : null}
                </div>
            </div>

            {shareTypeClick === 'shareWithFamily' && buliddata?.parentRef !== null ?
                <div className={classes.ShareBox}>
                    <div className={classes.ShareAppsMain}>
                        <button className={classes.copyButton} onClick={() => setModal('copy')} >
                            <div className={classes.shareApps}>
                                <div style={{ marginRight: '12px' }}>
                                    <CopyLinkSvg />
                                </div>
                                <div>Copy link</div>
                            </div>
                        </button>
                        <hr />
                        <div className={classes.shareApps}>
                            <div style={{ marginRight: '12px' }}>
                                <SensitiveSvg />
                            </div>
                            <div style={{ color: '#FF3566', fontSize: '12px' }}>Sensitive data will be disclosed (prices, names, confirmations, etc.)</div>
                        </div>
                    </div>
                </div> : shareTypeClick === 'publicShare' && buliddata?.parentRef !== null ? <div className={classes.ShareBox2}>
                    <div className={classes.ShareAppsMain}>
                        <div className={classes.shareApps} onClick={() => setModal('Facebook')}>
                            <div style={{ marginRight: '12px' }}>
                                <FacebookSvg />
                            </div>
                            <div>Share</div>
                        </div>
                        <div className={classes.shareApps} onClick={() => setModal('Linkedin')}>
                            <div style={{ marginRight: '12px' }}><LinkedinIcon style={{ width: 20, height: 20 }} /></div>
                            <div>Linkedin</div>
                        </div>
                        <div className={classes.shareApps} onClick={() => setModal('Twitter')}>
                            <div style={{ marginRight: '12px' }}>
                                <TwitterSvg />
                            </div>
                            <div>Tweet</div>
                        </div>

                        <div className={classes.shareApps} onClick={() => setModal('Whatsapp')}>
                            <div style={{ marginRight: '12px' }}>
                                <WhatsAppSvg />
                            </div>
                            <div>Share</div>
                        </div>
                        <button className={classes.copyButton} onClick={() => setModal('copy')} >
                            <div className={classes.shareApps}>
                                <div style={{ marginRight: '12px' }}>
                                    <CopyLinkSvg />
                                </div>
                                <div>Copy link</div>
                            </div>
                        </button>
                    </div>
                </div> : shareTypeClick === 'publicShare' && buliddata?.parentRef === null ?
                    <div className={classes.ShareBox2}>
                        <div className={classes.ShareAppsMain}>
                            <FacebookShareButton
                                url={newURL}
                                quote={buliddata?.name}
                            >
                                <div className={classes.shareApps} >
                                    <div style={{ marginRight: '12px' }}>
                                        <FacebookSvg />
                                    </div>
                                    <div>Facebook</div>
                                </div>
                            </FacebookShareButton>
                            <WhatsappShareButton
                                url={newURL}
                            >
                                <div className={classes.shareApps} >
                                    <div style={{ marginRight: '12px' }}>
                                        <WhatsAppSvg />
                                    </div>
                                    <div>Whatsapp</div>
                                </div>
                            </WhatsappShareButton>
                            <TwitterShareButton
                                title={buliddata.name}
                                url={newURL}
                            >
                                <div className={classes.shareApps} >
                                    <div style={{ marginRight: '12px' }}>
                                        <TwitterSvg />
                                    </div>
                                    <div>Tweet</div>
                                </div>
                            </TwitterShareButton>
                            <button className={classes.copyButton} >
                                <div className={classes.shareApps} onClick={() => handelCopyLink()}>
                                    <div style={{ marginRight: '12px' }}>
                                        <CopyLinkSvg />
                                    </div>
                                    <div>Copy link</div>
                                </div>
                            </button>
                        </div>
                    </div >
                    : shareTypeClick === 'shareWithFamily' && buliddata?.parentRef === null ?
                        <div className={classes.ShareBox2}>
                            <div className={classes.ShareAppsMain}>
                                <button className={classes.copyButton} >
                                    <div className={classes.shareApps} onClick={() => handelCopyLink()}>
                                        <div style={{ marginRight: '12px' }}>
                                            <CopyLinkSvg />
                                        </div>
                                        <div>Copy link</div>
                                    </div>
                                </button>
                            </div>
                        </div>
                        : null}

            {/* --------trip heading and days}---------------*/}

            <div className={classes.tripHeading}>
                <div className={classes.tripName}>{buliddata?.name}</div>
                <div className={classes.tripDate}>{moment.utc(buliddata?.startDate).format('ddd, MMM DD')} - {moment.utc(buliddata?.endDate).format('ddd, MMM DD')}</div>
            </div>
            {checkSpacing(buliddata?.tripOverview ? buliddata?.tripOverview : null) && buliddata?.type === 'Actual' ? <div className={classes.OverviewContainer}>
                <div className={classes.tripOverviewHeading}>Important Information</div>
                <div className={classes.box}>
                    <div id="eventMonitor" className={classes.comment} dangerouslySetInnerHTML={{ __html: buliddata?.tripOverview }}></div>

                </div>
            </div> : null}
            {/*-------------- General Information Section -------------- */}
            {
                ShareType !== 'friends' && flag && buliddata && buliddata.type === 'Actual' ?
                    <div className={classes.OverviewContainer}>

                        <div className={classes.tripOverviewHeading}>
                            General Information
                        </div>
                        <div className={classes.boxImp}>
                            {buliddata?.days?.map((n) => n?.sorted?.map((node, index: number) => {

                                return (
                                    <div key={index}>
                                        {isFlight(node) && node.type === "flight" && moment.utc(n.date).format("ddd MMM DD YYYY") === moment.utc(node.departDate).format("ddd MMM DD YYYY") ?
                                            <div style={{ marginBottom: '10px' }}>

                                                {(node.recordLocator || node.operatedByAirlineRecordLocator) && ShareType !== "friends" ?

                                                    <div className={cx(classes.flex, classes.vAlign)} onMouseLeave={() => setCopy(false)}>
                                                        <div className={classes.svgPadng}>
                                                            <FlightSvg width='22' height='22' />
                                                        </div>
                                                        <div className={classes.blockFirst}>
                                                            <div className={classes.date}>{moment.utc(node.departDate).format("ddd, MMM DD")}</div>
                                                            <div>
                                                                <div className={classes.tex1}>
                                                                    {node.flight.departureAirportCode}- {node.flight.arrivalAirportCode}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className={classes.blockSecond}>


                                                            <div className={cx(classes.date)} >Confirmations No: </div>

                                                            <div className={cx(classes.confirmno)} >
                                                                {node.operatedByAirlineRecordLocator ? node.operatedByAirlineRecordLocator : node.recordLocator}
                                                                <CopyToClipboard text={node.operatedByAirlineRecordLocator ? node.operatedByAirlineRecordLocator : node.recordLocator}>
                                                                    <span className={classes.copySVG}>
                                                                        <div>
                                                                            <CopySvg onClick={() => Copy(index, node)} />
                                                                            {!copyy ? <title className={classes.tooltip}>Copy</title> : null}

                                                                            <span>
                                                                                {copyy && indexx === index && moment.utc(n.date).format("ddd MMM DD YYYY") === moment.utc(date).format("ddd MMM DD YYYY") ? <button className={classes.tooltip}>{!copyy ? null : 'Copied'}</button> : null}
                                                                            </span>
                                                                        </div>
                                                                    </span>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>

                                                    </div> : null}
                                            </div> : node.type === "cruises" && isCruise(node) ?
                                                <div style={{ marginBottom: '10px' }}>
                                                    {node.deckNumber ?
                                                        <div className={classes.flex} onMouseLeave={() => setCopy(false)}>
                                                            <CruiseSvg width={"24"} height={"24"} />
                                                            <div className={classes.blockFirst}>
                                                                <div className={classes.text}>
                                                                    {moment.utc(node.departureDate).format("ddd, MMM DD")}
                                                                </div>
                                                                <div className={classes.tex1}>
                                                                    {node.cruise.departurePort}- {node.cruise.returnPort}

                                                                </div>
                                                            </div>
                                                            <div className={classes.blockSecond}>
                                                                <div className={cx(classes.date)} >Confirmations No: </div>

                                                                {node.deckNumber ? <div className={cx(classes.confirmno)} >{node.deckNumber}
                                                                    <CopyToClipboard text={node.deckNumber}>
                                                                        <span className={classes.copySVG}>
                                                                            <div>
                                                                                <CopySvg onClick={() => Copy(index, node)} />
                                                                                {!copyy ? <title className={classes.tooltip}>Copy</title> : null}
                                                                                <span>
                                                                                    {copyy && indexx === index && moment.utc(n.date).format("ddd MMM DD YYYY") === moment.utc(date).format("ddd MMM DD YYYY") ? <button className={classes.tooltip}>{!copyy ? null : 'Copied'}</button> : null}
                                                                                </span>
                                                                            </div>
                                                                        </span>
                                                                    </CopyToClipboard>
                                                                </div> : null}
                                                            </div>



                                                        </div> : null}
                                                </div> : node.type === "ferry" && isFerry(node) && node.duplicate && node.duplicate !== 'true' ?
                                                    <div >
                                                        {node.confirmationNumber ?
                                                            <div className={cx(classes.flex, classes.vAlign)} onMouseLeave={() => setCopy(false)}>
                                                                <SailingIcon className={classes.icon} />
                                                                <div className={classes.textPadng}>
                                                                    <div className={classes.text}>
                                                                        {moment.utc(revertDate(node.departDate)).format("ddd, MMM DD")}
                                                                    </div>

                                                                </div>

                                                                {node.ferry.logo !== null ?
                                                                    <div className={classes.imgPadng}>
                                                                        <img src={node.ferry.logo?.url ? node.ferry.logo?.url : ''} alt='ferry' />
                                                                    </div> : null}
                                                                <div className={classes.confrmtnPadng}>
                                                                    {node.confirmationNumber ? <div className={cx(classes.confirmno)} >   {node.confirmationNumber}
                                                                        <CopyToClipboard text={node.confirmationNumber}>
                                                                            <span className={classes.copySVG}>
                                                                                <div>
                                                                                    <CopySvg onClick={() => Copy(index, node)} />
                                                                                    <span>
                                                                                        {copyy && indexx === index && moment.utc(n.date).format("ddd MMM DD YYYY") === moment.utc(date).format("ddd MMM DD YYYY") ? <button className={classes.tooltip}>{!copyy ? null : 'Copied'}</button> : null}
                                                                                    </span>
                                                                                </div>
                                                                            </span>
                                                                        </CopyToClipboard>
                                                                    </div> : null}
                                                                </div>
                                                            </div> : null}
                                                    </div> : null}
                                    </div>)
                            }))}
                            <div className={classes.impInfoBottom}>
                                {buliddata?.tripAdvisoryConfirmation?.length > 0 ?
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>{buliddata?.tripAdvisoryConfirmation.map((conf) => {
                                        return <a download href={conf?.url} target="_blank" rel="noreferrer"><span>
                                            <HintsSvg />
                                        </span>Getting ready: tips and hints</a>
                                    })}</div> :
                                    buliddata?.tripAdvisory !== null ?
                                        <div><a download href={buliddata?.tripAdvisory?.url} target="_blank" rel="noreferrer"><span>
                                            <HintsSvg />
                                        </span>Getting ready: tips and hints</a></div> : null}
                                {buliddata?.healthAdvisory !== null ? <div><a download href={buliddata?.healthAdvisory?.url} target="_blank" rel="noreferrer"><span>
                                    <HintsSvg />
                                </span>COVID-19: info and support</a></div> : null}

                            </div>
                            {buliddata?.customUrls.length > 0 ?
                                <div className={classes.impInfoBottom}>
                                    {buliddata?.customUrls?.map((links) => {
                                        return <a href={links?.url} target="_blank" rel="noreferrer">
                                            <span>
                                                <LinkSvg />
                                            </span>{links?.name}
                                        </a>
                                    })}</div> : null}
                        </div>
                    </div > : null
            }

            {/* ----------------------- Trip Overview----------------- */}


            {buliddata?.comment?.trim() !== '' ? <div className={classes.OverviewContainer}>
                <div className={classes.tripOverviewHeading}>Trip Overview</div>
                <div className={classes.box}>
                    {buliddata?.comment && <div id="eventMonitor" className={classes.comment} dangerouslySetInnerHTML={{ __html: buliddata?.comment }}></div>}

                </div>
            </div> : null}

            {/* ------------------Insurance section ----------------------- */}
            {buliddata && buliddata?.itineraryInsurance.length > 0 ?
                <div style={{ marginBottom: '30px' }}>
                    <p className={classes.sliderHead}><span>Insurance</span></p>
                    {buliddata.itineraryInsurance.map((item, indexes) => {
                        return <div>
                            <div style={{ display: 'flex', gap: '5px', marginBottom: '15px' }}>
                                {item.persons.map((name, index) => {
                                    return <p className={classes.Header} style={{ fontSize: '16px' }}>{name.firstname} {name.lastname}{index !== item.persons.length - 1 && ','}</p>
                                })}
                            </div>
                            <div className={classes.grids}>
                                {item?.insurances.filter((sug, ind: number) => { return ind >= currentIndices[indexes]?.start && ind <= currentIndices[indexes]?.end }).map((node, indd: number) => {
                                    return <>
                                        <InsuranceSlider
                                            handleInsurance={handleInsurance}
                                            singleNode={node}
                                            ind={indexes}
                                        />
                                    </>
                                })}
                            </div>
                            {item.insurances.length > 3 || (window.innerWidth < 600 && item.insurances.length > 1) ? <div>
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    <button disabled={currentIndices[indexes]?.start === 0} onClick={() => handleSlide('backwards', indexes)} className={currentIndices[indexes]?.start === 0 ? classes.disableCard : classes.slide}>
                                        <BackSlideSvg />
                                    </button>
                                    <button className={currentIndices[indexes]?.end === item.insurances.length - 1 ? classes.disableCard : classes.slide}
                                        disabled={currentIndices[indexes]?.end === item.insurances.length - 1}
                                        onClick={() => handleSlide('forwards', indexes)}>
                                        <ForSlideSvg />
                                    </button>
                                </div>
                            </div> : null}
                        </div>
                    })}

                </div> : null}



            {/* -------------- Days Overview Section -------------- */}
            <div className={classes.OverviewContainer}>
                <div className={classes.Header}>Days overview ({buliddata?.days.length} days)</div>
            </div>
            {buliddata?.days && buliddata?.days.length > 0 ? <div className={classes.daysList}>
                <div>
                    <Days days={days} setDays={setDays} buliddata={buliddata} setbuilddata={setbuilddata} selectArray={selectArray} setSelectedArray={setSelectedArray} cartItems={cartItems} setCartItems={setCartItems} />
                </div>
            </div> : null}


            {/* ------------ Submit Proposal ------------- */}
            <div className={classes.SubmitButton} onClick={() => submitProposal()}>
                <button hidden={(selectArray.length > 0 || cartItems.length > 0) ? false : true} >
                    {handleButtonName()}
                </button>
            </div>


            {
                modals ? <SuccessPage successEmail={successEmail} setModal={setModals} buliddata={buliddata} cartItems={cartItems} /> : null
            }




        </div>
    )
}

export default NewActualDesign